/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import accountPropTypes from '../../../states/accounts/propTypes';
import AccountPickerMessage from '../AccountPicker/AccountPickerMessage';
import { contentPropTypes } from './PickerPaging.content';
import { ACCOUNT_PICKER_LAYOUT, PAYEE_PICKER_LAYOUT } from '../../constants';
import { payeePropTypes } from '../../../sharedComponents/PayeeList/propTypes';

const getMessage = ({
	numberOfFavourites,
	accountsNeverFetched,
	accounts,
	payees,
	layoutType,
	payeesNeverFetched,
	showPayees,
	isManageYourPayee,
	content: { accountsNoFavouritesText, noMatches, noResults },
}) => {
	if (layoutType === ACCOUNT_PICKER_LAYOUT) {
		if (accounts.length === 0 && !accountsNeverFetched) {
			return noMatches;
		}
		if (numberOfFavourites === 0) {
			return accountsNoFavouritesText;
		}
	}
	if (layoutType === PAYEE_PICKER_LAYOUT) {
		if (!isManageYourPayee && !showPayees && accounts.length === 0 && !accountsNeverFetched) {
			return noMatches;
		}
		if (payees.length === 0 && !payeesNeverFetched && showPayees) {
			return noResults;
		}
	}
	return '';
};

const PickerMessage = (props) => {
	const message = getMessage(props);
	if (!message) {
		return null;
	}
	return <AccountPickerMessage message={message} />;
};

PickerMessage.propTypes = {
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	accountsNeverFetched: PropTypes.bool,
	numberOfFavourites: PropTypes.number,
	payees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)),
	layoutType: PropTypes.string.isRequired,
	payeesNeverFetched: PropTypes.bool,
	showPayees: PropTypes.bool,
	content: PropTypes.shape(contentPropTypes),
};

export default PickerMessage;
